<template>
	<canvas ref="canvas" ></canvas>
</template>
<script>

import QRCode from 'qrcode'

export default {
	props: {
		contenido: String
	},
	data() {
		return {
			loading: false,
			error: undefined
		}
	},
	methods: {
		async generateQR(){ 
			try {

				this.loading = true
				const canvas = this.$refs.canvas;
				const contenido = this.contenido
				const codigoQR = await QRCode.toDataURL(contenido)
				
				let resp = await new Promise( (res,rej)=>QRCode.toCanvas(canvas, contenido, error=>!!error?rej(error):res(true)))
					
			} catch (err) {
				this.error = err
			}finally{
				this.loading = false
			}
		}
	}
	,watch:{
		contenido(){
			
			if(this.contenido){
				this.generateQR()
			}
		}
	}
}

</script>